<template>
  <div :class="`event-date ${textColor}`">
    <p class="date-range">{{ dateRange }}</p>
    <p class="countdown" v-if="enableCountdown && started">{{ duration }}</p>
  </div>
</template>

<script>
import Vue from "vue";
import moment from 'moment-timezone';

export default Vue.extend({
  name: "event-date",
  props: {
    startDate: String,
    endDate: String,
    timezone: String,
    enableCountdown: {
      type: Boolean,
      default: false
    },
    theme: String
  },
  computed: {
    textColor() {
      return this.theme === "dark" ? "text-light" : "text-dark";
    },
    started: function() {
      // return true if startDate is equal to or past today
      return moment().diff(moment(this.startDate), 'days') >= 0;
    },
    dateRange: function() {
      const DATE_TIME_TZ_FORMAT = 'MMMM Do YYYY, h:mm a z';
      const DATE_TIME_FORMAT = 'MMMM Do YYYY, h:mm a';
      const DATE_FORMAT = 'MMMM Do YYYY';
      const TIME_FORMAT = 'h:mm a';
      if (!this.endDate) {
        return `${moment(this.startDate).tz(this.timezone).format(DATE_TIME_TZ_FORMAT)}`;
      }
      // Single Day - May 1st 2020, 9:00 - 12:00 pm CST
      // Multiple Days - May 1st 2020, 9:00 am - May 21st 2020, 12:00 pm CST
      const startDate = moment(this.startDate).tz(this.timezone).format(DATE_FORMAT);
      const endDate = moment(this.endDate).tz(this.timezone).format(DATE_FORMAT);

      if (startDate === endDate) {
        const startTime = moment(this.startDate).tz(this.timezone).format(TIME_FORMAT)
        const endTime = moment(this.endDate).tz(this.timezone).format(TIME_FORMAT)
        const tz = moment(this.endDate).tz(this.timezone).format('z')
        return `${startDate}, ${startTime} - ${endTime} ${tz}`
      }
      return `${moment(this.startDate).tz(this.timezone).format(
        DATE_TIME_FORMAT
      )} - ${moment(this.endDate).tz(this.timezone).format(DATE_TIME_TZ_FORMAT)}`;
    },
    duration: function() {
      const localStartDate = moment(this.startDate).tz(this.timezone);
      const localEndDate = moment(this.endDate).tz(this.timezone);
      const localCurrentTime = moment().tz(this.timezone);

      if(localCurrentTime.diff(localStartDate) < 0) {
        return;
      }


      // based on endDate, determine whether to show days, hours, or minutes remaining.
      if (localCurrentTime.diff(localEndDate, 'days') < 0) {
        const label =
          localEndDate.diff(localCurrentTime, 'days') > 1
            ? 'Days Left'
            : 'Day Left';

        return `(${localEndDate.diff(localCurrentTime, 'days')} ${label})`;
      }

      if (localCurrentTime.diff(localEndDate, 'hours') < 0) {
        const label =
          localEndDate.diff(localCurrentTime, 'hours') > 1
            ? 'Hours Left'
            : 'Hour Left';
        return `(${localEndDate.diff(localCurrentTime, 'hours')} ${label})`;
      }

      if (localCurrentTime.diff(localEndDate, 'minutes') < 0) {
        const label =
          localEndDate.diff(localCurrentTime, 'minutes') > 1
            ? 'Minutes Left'
            : 'Minute Left';
        return `(${localEndDate.diff(localCurrentTime, 'minutes')} ${label})`;
      }

      return '(Ended)';
    }
  }
});
</script>

<style>
.event-date p {
  margin: 0;
}
</style>
